export function preventEventDefaultHandler(event: {
  preventDefault: () => void;
}): void {
  event.preventDefault();
}
